<template>
    <main id="expertise-areas" class="text-image-section">
    <div id="expertise-information" class="text-container">
      <p class="section-subtitle">Aulas Oferecidas na escola</p>
      <h3 class="section-title">
        Oferecemos aula de canto, <br />
        violão, guitarra e piano
      </h3>
      <nav>
        <a href="/aulas" class="btn">Saiba mais</a>
      </nav>
    </div>
    <div id="expertise-image-container" class="image-container">
      <img src="img/foto-show.jpg" alt="show" />
    </div>
    <div id="other-services">
      <div class="service">
        <img src="img/pexels-pixabay-164873.jpg" alt="Partitura" />
        <i class="bi bi-book"></i>
        <div class="service-info">
          <h4>Teoria Musical</h4>
          <p>
            Aulas de teoria musical e percepção auditiva são inclusa em todas as
            aulas de instrumento e canto, proporcionando ao aluno desde o
            primeiro contato com o instrumento desenvolver a leitura de
            partituras, solfejo e percepção rítmica.
          </p>
        </div>
      </div>
      <div class="service">
        <img src="img/canto.jpg" alt="Partitura" />
        <i class="bi bi-music-note"></i>
        <div class="service-info">
          <h4>Apresentações</h4>
          <p>
            Todo final de bimestre a escola proporciona uma apresentação dos
            alunos em um lugar pré-definido na cidade. Os alunos se apresentam
            individualmente e em grupo, com o objetivo de socializar e preparar
            para o mercado de trabalho.
          </p>
        </div>
      </div>
      <div class="service">
        <img src="img/estudio.jpg" alt="Partitura" />
        <i class="bi bi-sliders2-vertical"></i>
        <div class="service-info">
          <h4>Estúdio para Gravações</h4>
          <p>
            Proporcionamos estúdio de gravação para desenvolver essa importante
            habilidade no aluno que é essencial na carreira de um músico estar
            apto a trabalhar dentro de um estúdio, principalmente com o
            metrônomo e múltiplas faixas.
          </p>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
export default {
    name:'AreasAtuacao'
}
</script>
